import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import * as totemLogsActions from 'action/totemLogs'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import Breadcrumb from 'component/Breadcrumb'
import Pagination from 'component/pagination/Pagination'

import Filter from 'component/totemLog/Filter'
import Table from 'component/totemLog/Table'
import Col from 'component/utils/Col'
import moment from 'moment'

const totemLogContainer = (props) => {
  const [stretchedOut, setStretchedOut] = useState(true)
  const [initialValues, setInitialValues] = useState({})
  const [isRenderTable, setIsRenderTable] = useState(false)

  useEffect(() => {
    props.clearTable()
  }, [])

  const { translate, fetchLogs, auth, logs } = props

  const mountDataFull = (dt, hour) =>
    new Date(`${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()} ${hour}`)

  const handleSubmit = (filters) => {
    setStretchedOut(false)
    setInitialValues(filters)
    setIsRenderTable(true)

    if (filters.dtStart && filters.dtEnd) {
      const dataSt = mountDataFull(
        filters.dtStart,
        filters.hourStart || '00:00'
      )
      const dataEnd = mountDataFull(filters.dtEnd, filters.hourEnd || '23:59')

      filters.dtStart = moment(dataSt).subtract(3, 'hours')
      filters.dtEnd = moment(dataEnd).subtract(3, 'hours')
    }

    fetchLogs(auth.user.totemToken, filters)
  }

  const BREADCRUMB_STEPS = [
    { link: '/', title: translate('mobile.home') },
    { title: translate('totem') },
    { title: translate('totem.logs.title'), strong: true },
  ]

  const renderContent = () => {
    if (!logs.length && stretchedOut) {
      return (
        <div>
          <h3>{`${translate('query.logs')}`}</h3>
          <Filter
            initialValues={initialValues}
            translate={translate}
            handleSubmit={handleSubmit}
          />
        </div>
      )
    }

    return (
      <Table
        translate={translate}
        valuesFilter={initialValues}
        logs={logs}
        submit={handleSubmit}
      />
    )
  }

  const handlePagination = (e) => {
    const params = {
      ...initialValues,
      dtEnd: initialValues.dtEnd ? initialValues.dtEnd._i : null,
      dtStart: initialValues.dtStart ? initialValues.dtStart._i : null,
    }
    params.page = e
    handleSubmit(params)
  }

  const renderPaginaton = () => {
    const { count, current, pages, logs } = props

    if (current === 1 && logs.length < 10) {
      return
    }

    return (
      <Col className='align-center'>
        <Pagination
          count={count}
          current={current}
          getPage={(e) => handlePagination(e)}
          pages={pages}
        />
      </Col>
    )
  }

  return (
    <div>
      <ContentHeader>{translate('totem.logs.title')}</ContentHeader>
      <Breadcrumb steps={BREADCRUMB_STEPS} />

      <div className={`${stretchedOut ? 'totem-query-logs-container' : ''}`}>
        {renderContent()}
      </div>

      {isRenderTable && renderPaginaton()}
    </div>
  )
}

const TotemLogContainerContainerTranslated = translate(null, { wait: true })(
  totemLogContainer
)

/* istanbul ignore next */
const mapStateToProps = ({ logReducer, paginateReducer }) => ({
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  logs: logReducer.logs,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...totemLogsActions, ...reportActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TotemLogContainerContainerTranslated)

totemLogContainer.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  fetchLogs: PropTypes.func.isRequired,
  logs: PropTypes.array.isRequired,
  current: PropTypes.number,
  pages: PropTypes.number,
  count: PropTypes.number,
  stretchedOut: PropTypes.bool,
  clearTable: PropTypes.func,
}
